import React, { useState } from 'react';
import { Box, Button, Input, Stack, Text, useToast } from '@chakra-ui/react';
import api from '../api';


const Login = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const toast = useToast();

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const response = await api.post('/token/', {
        username,
        password,
      });
      localStorage.setItem('access', response.data.access);
      localStorage.setItem('refresh', response.data.refresh);
      window.location.href = '/'; // Redirect to the main page after login
    } catch (error) {
      toast({
        title: 'Login failed',
        description: 'Please check your credentials and try again.',
        status: 'error',
        duration: 5000,
        isClosable: true,
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box maxW="md" mx="auto" mt="8" p="6" borderWidth="1px" borderRadius="lg" boxShadow="lg">
      <Text fontSize="2xl" mb="4" fontWeight="bold" textAlign="center">
        Login
      </Text>
      <form onSubmit={handleLogin}>
        <Stack spacing="4">
          <Input
            placeholder="Username"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            isRequired
          />
          <Input
            placeholder="Password"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            isRequired
          />
          <Button type="submit" colorScheme="blue" isLoading={loading}>
            Login
          </Button>
        </Stack>
      </form>
    </Box>
  );
};

export default Login;
